<template>
  <button
    @click="emit('click')"
    type="submit"
    class="border-logout hover:drop-shadow-bottom-blue-1 flex h-16 items-center border border-solid bg-white p-5">
    <p class="font-lexend text-subtitle-2 font-medium">
      {{ label }}
    </p>
  </button>
</template>

<script lang="ts" setup>
import { IConfirmationButtonEmits } from '@/interfaces/components/emits'

defineProps<{ label: string }>()

const emit = defineEmits<IConfirmationButtonEmits>()
</script>
